// extracted by mini-css-extract-plugin
export default {"underline":"UnderlineHeader_underline__+imuX","text":"UnderlineHeader_text__t1vUz"};